import React from "react";
import "./secondSection.css"

const Secondsection = () => {
    return(
        <div className="secondSecctionDiv">
            <div>
                <div className="loremip">
                <h1>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua consectetur adipiscing.</h1>
                <button>Get Started</button>
                </div>
                <div className="workoutDiv">
                <h1 className="workout">
                    Workout <br />
                    Program <br />
                    Made <br />
                    For You
                </h1>
                </div>
                
            </div>
            
        </div>
    )
}

export default Secondsection;